module.exports = __webpack_public_path__ + "img/resource-tech-image-70.e75ba38f.jpg";